import { EventEmitter } from '@angular/core';
import { AvisoIntegrationService } from 'IntegrationsApp/ts/services/aviso-integration.service';
import { UtilsService } from 'NewAngular/services/core/utils.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/utils.service";
import * as i2 from "IntegrationsApp/ts/services/aviso-integration.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i5 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i6 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i7 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
function AvisoActivateModalComponent_ycn_loading_symbol_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 6);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Sending email...");
} }
function AvisoActivateModalComponent_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 12);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("textContent", ctx_r0.errorMessage);
} }
function AvisoActivateModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7)(1, "div", 8)(2, "div", 9);
    i0.ɵɵtemplate(3, AvisoActivateModalComponent_div_4_div_3_Template, 1, 1, "div", 10);
    i0.ɵɵelementStart(4, "div", 11)(5, "b");
    i0.ɵɵtext(6, "To connect your Aviso integration to YCharts, please complete the following steps:");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 11);
    i0.ɵɵtext(8, " User should submit integration request to their Aviso support contact. Once approved, continue to activation below. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 11);
    i0.ɵɵtext(10, " By clicking on the Activate button, YCharts will associate your account to your Aviso information using your registered email. Once confirmed, the integration will be activated and you'll be able to import holdings. ");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.errorMessage !== "");
} }
export class AvisoActivateModalComponent {
    constructor(utilsService, avisoIntegrationService) {
        this.utilsService = utilsService;
        this.avisoIntegrationService = avisoIntegrationService;
        this.closeModalHandler = new EventEmitter();
        this.confirmHandler = new EventEmitter();
        this.errorMessage = '';
        this.loading = false;
        this.modalOpen = false;
    }
    openModal() {
        this.modalOpen = true;
    }
    closeModal() {
        this.modalOpen = false;
        this.errorMessage = '';
        this.closeModalHandler.emit();
    }
    onSubmit() {
        this.avisoIntegrationService.activateAvisoIntegration().subscribe({
            next: () => {
                this.closeModal();
                window.location.reload();
            },
            error: (err) => {
                this.loading = false;
                this.errorMessage = err.error.errorMessage;
            },
        });
    }
}
AvisoActivateModalComponent.ɵfac = function AvisoActivateModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AvisoActivateModalComponent)(i0.ɵɵdirectiveInject(i1.UtilsService), i0.ɵɵdirectiveInject(i2.AvisoIntegrationService)); };
AvisoActivateModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AvisoActivateModalComponent, selectors: [["ycn-aviso-integration-activate-modal"]], outputs: { closeModalHandler: "closeModalHandler", confirmHandler: "confirmHandler" }, standalone: false, decls: 6, vars: 6, consts: [[3, "closeModalHandler", "extraModalClasses", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [3, "loaderMessage", 4, "ngIf"], ["class", "modal-section", 4, "ngIf"], [3, "cancelHandler", "submitHandler", "submitButtonText"], [3, "loaderMessage"], [1, "modal-section"], [1, "row"], [1, "col"], ["class", "form-row text-red", 3, "textContent", 4, "ngIf"], [1, "form-row"], [1, "form-row", "text-red", 3, "textContent"]], template: function AvisoActivateModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function AvisoActivateModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function AvisoActivateModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, AvisoActivateModalComponent_ycn_loading_symbol_3_Template, 1, 1, "ycn-loading-symbol", 3)(4, AvisoActivateModalComponent_div_4_Template, 11, 1, "div", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "ycn-simple-modal-footer", 5);
        i0.ɵɵlistener("cancelHandler", function AvisoActivateModalComponent_Template_ycn_simple_modal_footer_cancelHandler_5_listener() { return ctx.closeModal(); })("submitHandler", function AvisoActivateModalComponent_Template_ycn_simple_modal_footer_submitHandler_5_listener() { return ctx.onSubmit(); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-dialog")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Activate Aviso Integration");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("submitButtonText", "Activate");
    } }, dependencies: [i3.NgIf, i4.LoadingSymbolComponent, i5.ModalBaseComponent, i6.SimpleModalFooterComponent, i7.SimpleModalHeaderComponent], encapsulation: 2 });
